export default {
    layout: {
        loading: 'Nagta-trade',
        trading: 'Nagta-trade'
    },
    footer: {
    },
    menu: {
        home: 'Home',
        staking: 'Matriks',
        port: 'PORT',
        internet: 'Network',
        me: 'Ako',
    },
    header: {
        selectLang: 'Pumili ng Wika',
        close: 'Isara',
        trading: 'Kalakalan',
        dashboard: 'Dashboard',
        subscribeMatrix: 'Mag-subscribe sa Matriks',
        portTaskCenter: 'Sentro ng Gawain PORT',
        network: 'Network',
        apiBinding: 'Pag-bind ng API',
        gridTree: 'Grid Tree',
        account: 'Account',
        documents: 'Mga Dokumento at Whitepaper',
        personalCenter: 'Personal na Sentro',
        language: 'Wika'
    },
    home: {
        recently1:'Komunidad',
        staticrewares: 'Static',
        recentlyName: 'Ledger',
        recentlyInfo: 'Detalye ng Kita',
        dataUpdate: 'Pag-update ng Data',
        realtime: 'Realtime·BSC',
        totalRevenue: 'Kabuuang Kita (USDT)',
        today: 'Ngayon',
        totalTradingVolume: 'Kabuuang Halaga ng Kalakalan',
        todayEarn: 'Kita Ngayon',
        share: 'Ibahagi sa Kaibigan',
        shareDesc: 'Ibahagi ang kita, mag-imbita at kumita ng gantimpala',
        directReferrals: 'Bilang ng Direktang Referral',
        teamMembers: 'Bilang ng Miyembro ng Team',
        thisWeek: 'Ngayong Linggo',
        copy: 'Kopya',
        recently: 'Pinakabagong Kita',
        netIncome: 'Netong Kita',
        dailyAverage: 'Araw-araw na Average',
        quantitativeIncome: 'Kwantitatibo',
        recommend: 'Rekomendasyon',
        port: 'PORT',
        bonus: 'Bonus',
        all: 'Lahat',
        todayTitle: 'Ngayon',
        loadingMore: 'Mag-load ng mas marami',
        recommendBonus: 'Bonus sa Rekomendasyon',
        portTaskPassed: 'Nakumpleto ang Gawain PORT',
        myProfit: 'Aking Kita/Pagkalugi',
        earningOnBitDeep: 'Kumita ako sa BitDeep',
        totalRevenueUsdt: 'Kabuuang Kita · USDT',
        consecutiveDays: 'Magkasunod na Araw',
        scanToJoin: 'I-scan para Sumali',
        uid: 'UID',
        referralBonus: 'Bonus sa Referral',
        shareTo: 'Ibahagi sa',
        eachReferral: 'Bonus sa Pagbabahagi',
        screenshotAndShare: 'Screenshot at Ibahagi',
        saveShareEarn: 'I-save · I-forward · Kumita ng Gantimpala',
        period: 'Panahon',
        netProfit: 'Netong Kita',
        quantReward: 'Kwantitatibong Kita',
        dailyBonus: 'Araw-araw na Bonus PORT',
        close: 'Isara',
        permission: 'Pahintulot',
        onlyEnable: 'I-enable lamang',
        enterBitgetUid: 'Ilagay ang BITGET UID',
        slogan: 'Slogan',
        document: 'Dokumento',
        days: 'Araw',
        taskText: 'Gawain',
        minutes: 'Minuto',
        decentralizedPortTech: 'Desentralisadong arkitektura ng PoRT, ekonomiya ng token BGB, at dobleng insentibong matriks.',
        auditReport: 'Ulat ng Audit',
        faqSupport: 'FAQ & Suporta',
        telegram: 'Telegram',
        piece: 'Piraso',
        faq: 'Mga Madalas Itanong',
       faq1: 'Paano i-bind ang Bitget API?',
        faq1Desc: 'Pumunta sa Bitget Exchange → Settings → API Management para makuha ang API Key at Secret. I-enable lang ang Spot Trading; huwag kailanman i-enable ang withdrawal permission. I-paste ang keys sa BitDeep DApp. Kapag natapos ang 1 USDT test trade, aktibo na ang binding.',
        faq2: 'Ano ang PoRT (Proof of Real Trading)?',
        faq2Desc: 'PoRT ang pangunahing mekanismo ng "trading-as-mining". Araw-araw, ginagamit ng sistema ang iyong Bitget API para automatic na bumili at magbenta agad ng designated coin (hal. BGB). Kapag lumampas ang volume sa Stake × 50%, ve-verify ng sistema at ita-trigger ang araw-araw na reward.',
        faq3: 'Kailangan ko bang manu-manong i-monitor araw-araw?',
        faq3Desc: 'Hindi. Pagkatapos i-bind ang API, awtomatikong kinukumpleto ng sistema ang trading task sa loob ng 24-oras na window. Walang manual na aksyon na kailangan; pwede mong i-check sa PoRT menu.',
        faq4: 'Ano ang pagkakaiba ng ALPHA at SIGMA?',
        faq4Desc: 'ALPHA (Starter): 500 USDT stake, 0.3–1.3% daily yield, 1 plan lang. SIGMA (Pro): 1,000 USDT stake, 0.6–1.6% daily yield, hanggang 5 plans.',
        faq5: 'Ligtas ba ang pera ko? Pwede bang hawakan ng platform ang pondo ko?',
        faq5Desc: '100% nasa iyong sariling Bitget account ang iyong pondo. Read at spot-trading permissions lang ang ibinibigay ng API; hindi pwedeng mag-withdraw o mag-transfer ng anumang principal ang system.',
        faq6: 'Kailan sina-settle ang araw-araw na kita?',
        faq6Desc: 'Pagkatapos pumasa sa PoRT verification, ang settlement ay magaganap kinabukasan. Awtomatikong ilalabas ng sistema ang dalawahang reward: USDT earnings at 10x Deep points.',
        faq7: 'Paano kinakalkula ang Scout Bonus (Direct Referral Reward)?',
        faq7Desc: 'Para sa bawat active account na direkta mong na-refer, may fixed daily reward ka: 1 USDT/araw para sa ALPHA (500 USDT) referral, 2 USDT/araw para sa SIGMA (1,000 USDT), hanggang matapos ang cycle ng account na iyon.',
        faq8: 'Paano mag-level up (D1–D7)?',
        faq8Desc: 'Nag-le-level up base sa total volume ng minor zone. Halimbawa: D1 nangangailangan ng 2,000 USDT, D3 ng 15,000 USDT, D7 (pinakamataas) ng 3,000,000 USDT. Mas mataas ang level, mas malaki ang level-differential bonus (D7 hanggang 7 USDT/tao/araw).',
        faq9: 'Ilang araw ang isang cycle? Ano ang mangyayari pagkatapos?',
        faq9Desc: '28 araw ang isang cycle. Pagkatapos ng cycle, pwede mong piliing magpatuloy sa staking; ang reward ay binabayaran base sa aktwal na araw-araw na PoRT verification (variable yield).',
        faq10: 'May fee ba sa withdrawal?',
        faq10Desc:'0 fee ang withdrawals. Ibinabalik ng platform ang withdrawal fees sa pool para palakasin ang LP liquidity, lumilikha ng virtuous cycle.',
        bigArea: 'Malaking Lugar',
        smallArea: 'Maliit na Lugar',
        enterWithdrawAmount: 'Ilagay ang halaga ng withdrawal',
        all: 'Lahat',
        available: 'Magagamit',
        totalAmount: 'Kabuuang Halaga',
        confirmWithdraw: 'Kumpirmahin ang Withdrawal',
        withdrawRecord: 'Kasaysayan ng Withdrawal',
        withdrawn: 'Na-withdraw na',
        quickStartGuide:'Mabilis na Gabay',
        whitepaperGuide:'Whitepaper & Gabay',
         whitepaper:'Whitepaper',
        downloadPdf:'I-download'
    },
    staking: {
        selectPackage: 'Mag-subscribe sa Matriks',
        alpha: 'ALPHA',
        beginner: 'Baguhan',
        sigma: 'SIGMA',
        professional: 'Propesyonal',
        popular: 'Pinaka-Popular',
        dailyReturn: 'Mga Gantimpala sa Gawain ',
        teamDepth: 'Lalim ng Team',
        limitPurchase: 'Limitadong Pagbili',
        layer: 'Layer',
        copy: 'Piraso',
        autoRenew: 'Auto-renew kapag nag-expire',
        autoReinvest: 'Awtomatikong Pag-renew ng Margin',
        subscribeAlpha: 'Mag-subscribe sa Alpha',
        subscribeSigma: 'Mag-subscribe sa Sigma',
        stakedAmount: 'Margin',
        stakedAmount2: 'Panahon',
        stakedAmount3: 'Naipong Kita',
        stakingTime: 'Oras ng Paglahok',
        maturityTime: 'Oras ng Pag-expire',
        redeem: 'I-redeem',
        renew: 'I-renew',
        autoRenewActive: 'Auto-renew Aktibo',
        autoRenewInactive: 'Auto-renew Hindi Aktibo',
        smartContract: 'Smart contract management, Margin 28 araw, magbubukas sa expiration.',
        alter2:'Kung nag-expire na ang pangako, paki-renew ito.',
    },
    me: {
        account: 'Account',
        my: 'Akin',
        staked: 'Lumahok na',
        staked1:'Margin',
        points: 'Puntos',
        consecutive: 'Magkasunod na Araw',
        withdraw: 'Withdraw',
        language: 'Wika',
        simplifiedChinese: 'Simplified Chinese',
        disconnectWallet: 'I-disconnect ang Wallet',
        level: 'Antas',
        joinDate: 'Petsa ng Pagsali',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: 'Pag-bind ng API',
        bindDesc: 'I-bind ang API key ng exchange para sa awtorisadong kalakalan',
        apiKey: 'API Key',
        apiSecret: 'API Secret',
        exchange: 'Exchange',
        futures: 'Kontrata',
        spot: 'Spot',
        readOnly: 'Basahin lamang',
        bind: 'I-bind',
        riskNote: 'Ginagamit lamang ang API key para sa pag-sync ng data ng kalakalan, hindi nag-iimbak ng sensitibong impormasyon',
        apiConnection: 'Koneksyon ng API',
        bindExchangeApi: 'I-bind ang API ng Exchange',
        bitDeepRead: 'Binabasa ng BitDeep ang order flow ng iyong CEX account para patunayan ang tunay na kalakalan (PoRT).',
        noWithdraw: 'Hindi namin kailanman hinahawakan ang iyong withdrawal.',
        securityTip: 'Tip sa Seguridad · Pakibasa nang mabuti',
        close: 'Isara',
        withdraw: 'Withdraw',
        permission: 'Pahintulot',
        onlyEnable: 'I-enable lamang',
        spotTrading: 'Kalakalan sa Spot',
        read: 'Basahin',
        recommendedPartner: 'Inirerekomendang Partner',
        zeroFee: '0% Bayad',
        activated: 'Na-activate',
        classicAccount: 'Classic Account',
        unifiedAccount: 'Unified Account',
        bindBitgetApi: 'I-bind ang Bitget API',
        upcoming: 'Paparating',
        underAudit: 'Nasa Audit',
        expected: 'Inaasahan'
    },
        port: {
        portTaskCenter: 'Sentro ng Gawain PORT',
        dailyTask: 'Araw-araw na Gawain',
        verify: 'Beripikahin',
        completed: 'Nakumpleto',
        incomplete: 'Hindi Kumpleto',
        verifyStandard: 'Pamantayan sa Beripikasyon',
        tradingVolume: 'Halaga ng Kalakalan',
        today: 'Ngayon',
        deadline: 'Deadline',
        reward: 'Gantimpala',
        startVerify: 'Simulan ang Beripikasyon',
        verifying: 'Nagbe-beripika',
        verified: 'Na-beripika',
        insufficient: 'Hindi sapat',
        viewDetails: 'Tingnan ang Detalye',
        taskList: 'Listahan ng Gawain',
        allTasks: 'Lahat ng Gawain',
        completedTasks: 'Nakumpleto',
        pendingTasks: 'Naka-pending',
        proofOfRealTrading: 'Patunay ng Tunay na Kalakalan',
        todayTask: 'Gawain Ngayon',
        todayStaticIncome: 'Mga Gantimpala sa Gawain Ngayon',
        points: 'Puntos',
        todayWindowClosesAt: 'Ang bintana ngayong araw ay magsasara sa',
        checkTaskStatus: 'Suriin ang Katayuan ng Gawain',
        teamProgress: 'Pag-unlad ng Team · Ngayon',
        realtimePortCompletion: 'Realtime na Pagkumpleto ng PORT',
        completedText: 'Nakumpleto',
        pendingText: 'Naka-pending',
        realtimeApiValidationFlow: 'Realtime · API · Daloy ng Beripikasyon',
        rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
    },
    internet: {
        network: 'Network',
        treeBrowser: 'Tree Browser',
        searchAddress: 'Maghanap ng 0x...address o BD-ID',
        totalTradingVolume: 'Kabuuang Halaga ng Kalakalan',
        members: 'Mga Miyembro',
        networkStructure: 'Istruktura ng Network',
        allLevels: 'Lahat ng Antas',
        addRemark: 'Magdagdag ng Tala',
        enterRemark: 'Ilagay ang Tala',
        cancel: 'Kanselahin',
        confirm: 'Kumpirmahin',
        alert1:'Share Performance',
    alert2:'Team Performance',
    alert3:'Task Status',
    },
    withdraw: {
        withdraw: 'Withdraw',
        usdtAsset: 'USDT Asset',
        withdrawAmount: 'Halaga ng Withdrawal',
        availableBalance: 'Magagamit na Balanse',
        fee: 'Bayad',
        actualArrival: 'Aktwal na Natanggap',
        submit: 'Ipasa',
        withdrawSuccess: 'Matagumpay na Withdrawal',
        withdrawFailed: 'Nabigong Withdrawal',
        processing: 'Pinoproseso',
        completed: 'Nakumpleto',
        withdrawHistory: 'Kasaysayan ng Withdrawal'
    },
    popup: {
        taskUnfinished: 'Hindi Natapos na Gawain',
        taskUnfinishedDesc: 'Ang data ng kalakalan ay hindi umabot sa pamantayan ng beripikasyon ng PoRT ngayong araw',
        todayTradingVolume: 'Halaga ng Kalakalan Ngayon',
        remaining: 'Natitira',
        toComplete: 'para makumpleto ang gawain ngayong araw',
        tradingVolumeThreshold: '',
        deadline: 'Oras na natitira bago ang deadline ng gawain',
        tryAgain: 'Subukan muli mamaya',
        goTrade: 'Pumunta sa Kalakalan',
        taskCompleted: 'Nakumpleto ang Gawain',
        taskCompletedDesc: 'Ang patunay ng kalakalan ng PoRT ngayong araw ay matagumpay na naitala sa blockchain',
        rewardIssued: 'Naibigay na ang Gantimpala',
        complete: 'Nakumpleto',
        shareTitle: 'Ibahagi ang Imbitasyon',
        shareDesc: 'Mag-imbita ng kaibigan na magrehistro, parehong makakakuha ng gantimpala',
        referralLink: 'Link ng Imbitasyon',
        qrCode: 'QR Code',
        copyLink: 'Kopyahin ang Link',
        notask:'Walang task ngayon',
        notaskDesc:'Wala pang nakabinbing PoRT trading tasks sa kasalukuyan',
    }
};
